import { ChangeDetectionStrategy, Component } from '@angular/core';
import {  UnsubscribeService } from '@common/services';
@Component({
  templateUrl: 'problem-manual.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UnsubscribeService]
})
export class ProblemManualComponent {}
